<div class="content-wrapper-inner page-content">
  <h4 class="mb-20">MoneySMS Support</h4>

  <!-- Tabs -->
  <ul class="nav nav-tabs mb-20">
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'manual'" (click)="switchTab('manual')" href="javascript:void(0)">Manual Tickets</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'closed'" (click)="switchTab('closed')" href="javascript:void(0)">Closed Tickets</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'autoclose'" (click)="switchTab('autoclose')" href="javascript:void(0)">Autoclosed Tickets</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'instructions'" (click)="switchTab('instructions')" href="javascript:void(0)">Instructions</a>
    </li>
  </ul>

  <!-- Ticket filters -->
  <div *ngIf="activeTab !== 'instructions'" class="d-flex align-items-center gap-10 mb-15">
    <!-- ID search -->
    <div class="d-flex align-items-center position-relative">
      <input
        type="search"
        class="form-control table-search ps-35"
        placeholder="Ticket ID or phone…"
        [(ngModel)]="ticketSearch"
        (ngModelChange)="recomputeFilteredTickets()" />
      <span class="position-absolute icon-search ps-10"></span>
    </div>

    <!-- Case filter -->
    <div class="filter-tab dropdown">
      <a
        class="dropdown-toggle d-flex justify-content-center align-items-center"
        role="button"
        id="filter-support-case"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        data-bs-auto-close="outside"
        [class.active]="isCaseFilterActive">
        Case<span *ngIf="selectedCaseNames.size > 0">&nbsp;({{ selectedCaseNames.size }})</span>
      </a>
      <div class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1" aria-labelledby="filter-support-case">
        <div class="mx-10">
          <div *ngIf="selectedCaseNames.size > 0" class="d-flex justify-content-end mt-5 mb-5">
            <span class="cp text-neutral-n7 text-decoration-underline" style="font-size: 13px" (click)="clearCaseFilter()">Clear all</span>
          </div>
          <div
            *ngFor="let c of casesForFilter"
            class="d-flex justify-content-start align-items-center gap-10 my-10 cp"
            (click)="toggleCaseFilter(c.name)">
            <div class="input-check">
              <input type="checkbox" class="form-check-input" [checked]="selectedCaseNames.has(c.name)" (click)="$event.preventDefault()" />
            </div>
            <span>{{ c.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══════════════════ Manual Tickets Tab ═══════════════════ -->
  <div *ngIf="activeTab === 'manual'">
    <!-- Auto mode status bar -->
    <div class="alert d-flex align-items-center mb-15" [ngClass]="autoModeState.enabled ? 'alert-success' : 'alert-secondary'">
      <button class="btn btn-sm btn-outline-secondary me-15" (click)="loadManualTickets()"><i class="fas fa-sync-alt"></i> Refresh</button>
      <strong class="me-10">Auto Mode</strong>
      <div class="form-check form-switch mb-0">
        <input
          class="form-check-input"
          type="checkbox"
          [checked]="autoModeState.enabled"
          [disabled]="autoModeToggleInFlight"
          (change)="toggleAutoMode()" />
      </div>
      <span class="ms-15">Manual: {{ autoModeState.manualCount }}</span>
      <button class="btn btn-sm btn-outline-warning ms-10" (click)="resetAutoMode()">Reset</button>
    </div>

    <div *ngIf="manualLoading" class="text-center py-30">
      <div class="spinner-border text-primary" role="status"></div>
    </div>

    <div *ngIf="!manualLoading && manualTickets.length === 0" class="text-muted text-center py-30">No manual tickets in queue.</div>

    <div *ngIf="!manualLoading && manualTickets.length > 0 && filteredManualTickets.length === 0" class="text-muted text-center py-30">
      No tickets match the search.
    </div>

    <div *ngIf="!manualLoading && filteredManualTickets.length > 0" class="table-responsive">
      <table class="table table-sm table-hover align-middle">
        <thead class="table-light">
          <tr>
            <th class="cp" (click)="toggleManualSort('ticketId')" style="width: 100px">
              Ticket ID <i [class]="sortIcon(manualSort, 'ticketId')"></i>
            </th>
            <th>Subject</th>
            <th class="cp" (click)="toggleManualSort('phoneNumber')">Phone <i [class]="sortIcon(manualSort, 'phoneNumber')"></i></th>
            <th>Cases</th>
            <th style="width: 90px">Action</th>
            <th class="cp" (click)="toggleManualSort('replies')" style="width: 80px">Replies <i [class]="sortIcon(manualSort, 'replies')"></i></th>
            <th class="cp" (click)="toggleManualSort('reviewCachedAt')">Reviewed At <i [class]="sortIcon(manualSort, 'reviewCachedAt')"></i></th>
            <th style="min-width: 220px">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let t of filteredManualTickets; trackBy: trackByTicketId" class="cp" (click)="openTicketDetail(t.ticketId)">
            <td>
              <a [href]="freshdeskUrl(t.ticketId)" target="_blank" (click)="$event.stopPropagation()">#{{ t.ticketId }}</a>
            </td>
            <td>{{ t.decision?.subject || '-' }}</td>
            <td>{{ t.decision?.phoneNumber || '-' }}</td>
            <td>{{ formatSupportCaseNames(t.decision) }}</td>
            <td>
              <span *ngIf="t.decision" [ngClass]="getActionBadgeClass(t.decision.action?.type)">{{ t.decision.action?.type || '-' }}</span>
              <span *ngIf="!t.decision">-</span>
            </td>
            <td>{{ ticketReplyCounts.has(t.ticketId) ? ticketReplyCounts.get(t.ticketId) : '-' }}</td>
            <td>{{ formatDate(t.reviewCachedAt) }}</td>
            <td (click)="$event.stopPropagation()">
              <button
                class="btn btn-sm btn-primary me-10"
                (click)="performAction(t.ticketId, 'solve')"
                [disabled]="isTicketBusy(t.ticketId)"
                title="Solve">
                Solve
              </button>
              <button
                class="btn btn-sm btn-outline-secondary me-10"
                (click)="performAction(t.ticketId, 'close')"
                [disabled]="isTicketBusy(t.ticketId)"
                title="Close">
                Close
              </button>
              <button
                class="btn btn-sm btn-outline-danger me-10"
                (click)="performAction(t.ticketId, 'spam')"
                [disabled]="isTicketBusy(t.ticketId)"
                title="Spam">
                Spam
              </button>
              <button
                class="btn btn-sm btn-outline-warning"
                (click)="retryTicket(t.ticketId)"
                [disabled]="isTicketBusy(t.ticketId)"
                title="Re-evaluate">
                Re-try
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- ═══════════════════ Closed Tickets Tab ═══════════════════ -->
  <div *ngIf="activeTab === 'closed'">
    <div class="d-flex align-items-center mb-15">
      <label class="me-10 mb-0">Days:</label>
      <select class="form-select form-select-sm" style="width: 80px" [(ngModel)]="closedDays" (change)="onClosedDaysChange()">
        <option [ngValue]="1">1</option>
        <option [ngValue]="3">3</option>
        <option [ngValue]="7">7</option>
        <option [ngValue]="14">14</option>
        <option [ngValue]="30">30</option>
      </select>
      <button class="btn btn-sm btn-outline-secondary ms-10" (click)="loadClosedTickets()"><i class="fas fa-sync-alt"></i> Refresh</button>
    </div>

    <div *ngIf="closedLoading" class="text-center py-30">
      <div class="spinner-border text-primary" role="status"></div>
    </div>

    <div *ngIf="!closedLoading && closedTickets.length === 0" class="text-muted text-center py-30">
      No closed manual tickets in the selected period.
    </div>

    <div *ngIf="!closedLoading && closedTickets.length > 0 && filteredClosedTickets.length === 0" class="text-muted text-center py-30">
      No tickets match the search.
    </div>

    <div *ngIf="!closedLoading && filteredClosedTickets.length > 0" class="table-responsive">
      <table class="table table-sm table-hover align-middle">
        <thead class="table-light">
          <tr>
            <th class="cp" (click)="toggleClosedSort('ticketId')">Ticket ID <i [class]="sortIcon(closedSort, 'ticketId')"></i></th>
            <th>Subject</th>
            <th class="cp" (click)="toggleClosedSort('phoneNumber')">Phone <i [class]="sortIcon(closedSort, 'phoneNumber')"></i></th>
            <th>Cases</th>
            <th>Action</th>
            <th>Confidence</th>
            <th class="cp" (click)="toggleClosedSort('actedAt')">Closed At <i [class]="sortIcon(closedSort, 'actedAt')"></i></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let t of filteredClosedTickets; trackBy: trackByTicketId" class="cp" (click)="openTicketDetail(t.ticketId)">
            <td>
              <a [href]="freshdeskUrl(t.ticketId)" target="_blank" (click)="$event.stopPropagation()">#{{ t.ticketId }}</a>
            </td>
            <td>{{ t.decision?.subject || '-' }}</td>
            <td>{{ t.decision?.phoneNumber || '-' }}</td>
            <td>{{ formatSupportCaseNames(t.decision) }}</td>
            <td>
              <span [ngClass]="getActionBadgeClass(t.action)">{{ t.action }}</span>
            </td>
            <td>{{ formatConfidence(t.decision?.confidence) }}</td>
            <td>{{ formatDate(t.actedAt) }}</td>
          </tr>
        </tbody>
      </table>

      <!-- Pagination -->
      <nav *ngIf="closedPageCount > 1" class="d-flex align-items-center justify-content-between mt-10">
        <small class="text-muted">{{ closedTotal }} tickets total</small>
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" [class.disabled]="closedPage === 1">
            <a class="page-link" href="javascript:void(0)" (click)="goToClosedPage(closedPage - 1)">Previous</a>
          </li>
          <li *ngFor="let p of [].constructor(closedPageCount); let i = index" class="page-item" [class.active]="closedPage === i + 1">
            <a class="page-link" href="javascript:void(0)" (click)="goToClosedPage(i + 1)">{{ i + 1 }}</a>
          </li>
          <li class="page-item" [class.disabled]="closedPage === closedPageCount">
            <a class="page-link" href="javascript:void(0)" (click)="goToClosedPage(closedPage + 1)">Next</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>

  <!-- ═══════════════════ Autoclose Tickets Tab ═══════════════════ -->
  <div *ngIf="activeTab === 'autoclose'">
    <div class="d-flex align-items-center mb-15">
      <label class="me-10 mb-0">Days:</label>
      <select class="form-select form-select-sm" style="width: 80px" [(ngModel)]="autocloseDays" (change)="onAutocloseDaysChange()">
        <option [ngValue]="1">1</option>
        <option [ngValue]="3">3</option>
        <option [ngValue]="7">7</option>
        <option [ngValue]="14">14</option>
        <option [ngValue]="30">30</option>
      </select>
      <button class="btn btn-sm btn-outline-secondary ms-10" (click)="loadAutocloseTickets()"><i class="fas fa-sync-alt"></i> Refresh</button>
    </div>

    <div *ngIf="autocloseLoading" class="text-center py-30">
      <div class="spinner-border text-primary" role="status"></div>
    </div>

    <div *ngIf="!autocloseLoading && autocloseTickets.length === 0" class="text-muted text-center py-30">
      No auto-closed tickets in the selected period.
    </div>

    <div *ngIf="!autocloseLoading && autocloseTickets.length > 0 && filteredAutocloseTickets.length === 0" class="text-muted text-center py-30">
      No tickets match the search.
    </div>

    <div *ngIf="!autocloseLoading && filteredAutocloseTickets.length > 0" class="table-responsive">
      <table class="table table-sm table-hover align-middle">
        <thead class="table-light">
          <tr>
            <th class="cp" (click)="toggleAutocloseSort('ticketId')">Ticket ID <i [class]="sortIcon(autocloseSort, 'ticketId')"></i></th>
            <th>Subject</th>
            <th>Cases</th>
            <th>Confidence</th>
            <th class="cp" (click)="toggleAutocloseSort('cachedAt')">Closed At <i [class]="sortIcon(autocloseSort, 'cachedAt')"></i></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let t of filteredAutocloseTickets; trackBy: trackByTicketId" class="cp" (click)="openTicketDetail(t.ticketId)">
            <td>
              <a [href]="freshdeskUrl(t.ticketId)" target="_blank" (click)="$event.stopPropagation()">#{{ t.ticketId }}</a>
            </td>
            <td>{{ t.decision?.subject || '-' }}</td>
            <td>{{ formatSupportCaseNames(t.decision) }}</td>
            <td>{{ formatConfidence(t.decision?.confidence) }}</td>
            <td>{{ formatDate(t.cachedAt) }}</td>
          </tr>
        </tbody>
      </table>

      <!-- Pagination -->
      <nav *ngIf="autoclosePageCount > 1" class="d-flex align-items-center justify-content-between mt-10">
        <small class="text-muted">{{ autocloseTotal }} tickets total</small>
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" [class.disabled]="autoclosePage === 1">
            <a class="page-link" href="javascript:void(0)" (click)="goToAutoclosePage(autoclosePage - 1)">Previous</a>
          </li>
          <li *ngFor="let p of [].constructor(autoclosePageCount); let i = index" class="page-item" [class.active]="autoclosePage === i + 1">
            <a class="page-link" href="javascript:void(0)" (click)="goToAutoclosePage(i + 1)">{{ i + 1 }}</a>
          </li>
          <li class="page-item" [class.disabled]="autoclosePage === autoclosePageCount">
            <a class="page-link" href="javascript:void(0)" (click)="goToAutoclosePage(autoclosePage + 1)">Next</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>

  <!-- ═══════════════════ Instructions Tab ═══════════════════ -->
  <div *ngIf="activeTab === 'instructions'">
    <!-- ─── System Prompt Configuration ────────────────────── -->
    <div class="mb-30">
      <h5 class="mb-15">System Prompt</h5>

      <div *ngIf="promptConfigLoading" class="text-center py-20">
        <div class="spinner-border text-primary" role="status"></div>
      </div>

      <div *ngIf="!promptConfigLoading">
        <div *ngFor="let pc of promptConfigs" class="mb-20">
          <div class="d-flex align-items-center mb-10">
            <label class="form-label mb-0 fw-bold">{{ promptConfigLabel(pc.key) }}</label>
            <button class="btn btn-sm btn-outline-secondary ms-auto" (click)="openPromptConfigHistory(pc)">History</button>
          </div>
          <textarea class="form-control" rows="12" [(ngModel)]="pc.content"></textarea>
          <button class="btn btn-sm btn-primary mt-10" [disabled]="promptConfigSaving.has(pc.key)" (click)="savePromptConfig(pc)">Save</button>
        </div>
      </div>
    </div>

    <!-- ─── Support Cases ──────────────────────────────────── -->
    <div class="d-flex align-items-center mb-15">
      <h5 class="mb-0">Support Cases</h5>
      <button class="btn btn-sm btn-primary ms-auto" (click)="openCaseForm()">+ New Case</button>
    </div>

    <div *ngIf="casesLoading" class="text-center py-20">
      <div class="spinner-border text-primary" role="status"></div>
    </div>

    <div *ngIf="!casesLoading" class="table-responsive mb-30">
      <table class="table table-sm table-hover align-middle">
        <thead class="table-light">
          <tr>
            <th>Name</th>
            <th>Autoclose</th>
            <th>Sort Order</th>
            <th>Updated</th>
            <th style="min-width: 160px">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of cases; trackBy: trackByCaseId">
            <td>{{ c.name }}</td>
            <td>
              <div class="form-check form-switch mb-0">
                <input class="form-check-input" type="checkbox" [checked]="c.autoclose" (change)="toggleAutoclose(c)" />
              </div>
            </td>
            <td>{{ c.sortOrder }}</td>
            <td>{{ formatDate(c.updatedAt) }}</td>
            <td>
              <button class="btn btn-sm btn-outline-primary me-10" (click)="openCaseForm(c)">Edit</button>
              <button class="btn btn-sm btn-outline-danger me-10" (click)="deleteCase(c)">Delete</button>
              <button class="btn btn-sm btn-outline-secondary" (click)="openCaseHistory(c)">History</button>
            </td>
          </tr>
          <tr *ngIf="cases.length === 0">
            <td colspan="5" class="text-muted text-center">No support cases.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- ═══════════════════ Case Form Modal ═══════════════════ -->
<div
  *ngIf="showCaseForm"
  class="modal d-block"
  tabindex="-1"
  style="background: rgba(0, 0, 0, 0.5)"
  (click)="$event.target === $event.currentTarget ? closeCaseForm() : null">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ editingCase ? 'Edit Case' : 'New Case' }}</h5>
        <button type="button" class="btn-close" (click)="closeCaseForm()"></button>
      </div>
      <form [formGroup]="caseForm" (ngSubmit)="saveCase()">
        <div class="modal-body">
          <div class="mb-15">
            <label class="form-label">Name</label>
            <input class="form-control" formControlName="name" placeholder="Case name" />
          </div>
          <div class="mb-15">
            <label class="form-label">Instructions</label>
            <textarea
              class="form-control"
              formControlName="instructions"
              rows="8"
              placeholder="Case instructions..."
              #instructionsTextarea
              style="overflow-y: hidden; max-height: 60vh"
              (input)="
                instructionsTextarea.style.height = 'auto';
                instructionsTextarea.style.height = instructionsTextarea.scrollHeight + 'px';
                instructionsTextarea.style.overflowY = instructionsTextarea.scrollHeight > instructionsTextarea.clientHeight ? 'auto' : 'hidden'
              "></textarea>
          </div>
          <div class="mb-15">
            <label class="form-label">Sort Order</label>
            <input class="form-control" type="number" formControlName="sortOrder" style="max-width: 120px" />
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="autoclose" id="caseAutoclose" />
            <label class="form-check-label" for="caseAutoclose">Autoclose</label>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" (click)="closeCaseForm()">Cancel</button>
          <button type="submit" class="btn btn-primary" [disabled]="caseForm.invalid">Save</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- ═══════════════════ Case History Modal ═══════════════════ -->
<div
  *ngIf="showCaseHistory"
  class="modal d-block"
  tabindex="-1"
  style="background: rgba(0, 0, 0, 0.5)"
  (click)="$event.target === $event.currentTarget ? closeCaseHistory() : null">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Change History: {{ caseHistoryName }}</h5>
        <button type="button" class="btn-close" (click)="closeCaseHistory()"></button>
      </div>
      <div class="modal-body">
        <div *ngIf="caseHistory.length === 0" class="text-muted text-center py-20">No history.</div>
        <table *ngIf="caseHistory.length > 0" class="table table-sm">
          <thead class="table-light">
            <tr>
              <th>Field</th>
              <th>Old Value</th>
              <th>New Value</th>
              <th>Changed By</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let h of caseHistory">
              <td>{{ h.fieldName }}</td>
              <td class="text-truncate" style="max-width: 200px">{{ h.oldValue || '-' }}</td>
              <td class="text-truncate" style="max-width: 200px">{{ h.newValue || '-' }}</td>
              <td>{{ h.changedBy }}</td>
              <td>{{ formatDate(h.createdAt) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="closeCaseHistory()">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- ═══════════════════ Ticket Detail Modal ═══════════════════ -->
<div
  class="modal fade"
  [class.show]="showTicketDetail"
  [style.display]="showTicketDetail ? 'block' : 'none'"
  tabindex="-1"
  (click)="$event.target === $event.currentTarget ? closeTicketDetail() : null">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" *ngIf="ticketDetail">Ticket #{{ ticketDetail.ticketId }}</h5>
        <button type="button" class="btn-close" (click)="closeTicketDetail()"></button>
      </div>
      <div class="modal-body" style="min-height: 400px">
        <div *ngIf="ticketDetailLoading" class="text-center py-30">
          <div class="spinner-border text-primary" role="status"></div>
        </div>

        <div *ngIf="!ticketDetailLoading && ticketDetail" class="row">
          <!-- Left sidebar tabs -->
          <div class="col-2">
            <div class="nav flex-column nav-pills">
              <a
                class="nav-link"
                [class.active]="ticketDetailTab === 'conversation'"
                (click)="ticketDetailTab = 'conversation'"
                href="javascript:void(0)"
                >Conversation</a
              >
              <a class="nav-link" [class.active]="ticketDetailTab === 'decision'" (click)="ticketDetailTab = 'decision'" href="javascript:void(0)"
                >Bot Decision</a
              >
              <a class="nav-link" [class.active]="ticketDetailTab === 'data'" (click)="ticketDetailTab = 'data'" href="javascript:void(0)"
                >User Data</a
              >
            </div>
            <hr class="my-15" *ngIf="ticketDetailIsManual" />
            <div class="d-grid gap-10" *ngIf="ticketDetailIsManual">
              <button
                class="btn btn-sm btn-primary"
                (click)="performAction(ticketDetail.ticketId, 'solve', true)"
                [disabled]="isTicketBusy(ticketDetail.ticketId)">
                Solve
              </button>
              <button
                class="btn btn-sm btn-outline-secondary"
                (click)="performAction(ticketDetail.ticketId, 'close', true)"
                [disabled]="isTicketBusy(ticketDetail.ticketId)">
                Close
              </button>
              <button
                class="btn btn-sm btn-outline-danger"
                (click)="performAction(ticketDetail.ticketId, 'spam', true)"
                [disabled]="isTicketBusy(ticketDetail.ticketId)">
                Spam
              </button>
              <button
                class="btn btn-sm btn-outline-warning"
                (click)="retryTicket(ticketDetail.ticketId)"
                [disabled]="isTicketBusy(ticketDetail.ticketId)">
                Re-try
              </button>
            </div>
            <hr class="my-15" />
            <div class="d-grid">
              <a [href]="freshdeskUrl(ticketDetail.ticketId)" target="_blank" class="btn btn-sm btn-outline-primary">Open in Freshdesk</a>
            </div>
          </div>

          <!-- Right content -->
          <div class="col-10">
            <!-- Conversation tab -->
            <div *ngIf="ticketDetailTab === 'conversation'">
              <div *ngIf="!ticketDetail.ticket" class="text-muted">Ticket not found in Freshdesk.</div>

              <div *ngIf="ticketDetail.ticket">
                <!-- Subject -->
                <div *ngIf="ticketDetail.ticket.subject" class="card mb-10">
                  <div class="card-body py-10 d-flex align-items-baseline justify-content-between">
                    <span class="fw-bold">{{ ticketDetail.ticket.subject }}</span>
                    <small class="text-muted ms-10" style="white-space: nowrap"
                      >{{ cachedReversedConversations.length + 1 }} messages<span *ngIf="cachedReversedConversations.length > 10">
                        (full thread)</span
                      ></small
                    >
                  </div>
                </div>

                <!-- Conversations (newest first) -->
                <div *ngFor="let conv of cachedReversedConversations" class="card mb-10">
                  <div
                    class="card-header d-flex justify-content-between py-5"
                    [ngClass]="conv.incoming ? '' : conv.private ? 'bg-secondary bg-opacity-10' : 'bg-light'">
                    <strong>{{ conv.incoming ? conv.from_email || 'Customer' : conv.private ? 'Agent – private note' : 'Agent' }}</strong>
                    <small class="text-muted">{{ formatDate(conv.created_at) }}</small>
                  </div>
                  <div
                    class="card-body py-10 conversation-body"
                    [ngClass]="!conv.incoming && conv.private ? 'bg-secondary bg-opacity-10' : ''"
                    [innerHTML]="conv.body || conv.body_text || '(empty)'"
                    (click)="toggleConversationImage($event)"></div>
                  <div *ngIf="conv.attachments?.length" class="card-footer py-5 d-flex flex-wrap gap-5">
                    <ng-container *ngFor="let att of conv.attachments">
                      <img
                        *ngIf="att.content_type?.startsWith('image/')"
                        [src]="att.attachment_url"
                        [alt]="att.name || 'attachment'"
                        class="conversation-attachment-img"
                        (click)="toggleConversationImage($event)" />
                      <a
                        *ngIf="!att.content_type?.startsWith('image/')"
                        [href]="att.attachment_url"
                        target="_blank"
                        class="btn btn-sm btn-outline-secondary">
                        <i class="fas fa-paperclip me-5"></i>{{ att.name || 'Attachment' }}
                      </a>
                    </ng-container>
                  </div>
                </div>

                <!-- Original ticket (oldest, shown last) -->
                <div class="card mb-10">
                  <div class="card-header d-flex justify-content-between py-5">
                    <strong>{{
                      ticketDetail.ticket.requester?.name || ticketDetail.ticket.requester?.email || ticketDetail.ticket.email || 'Customer'
                    }}</strong>
                    <small class="text-muted">{{ formatDate(ticketDetail.ticket.created_at) }}</small>
                  </div>
                  <div
                    class="card-body py-10 conversation-body"
                    [innerHTML]="ticketDetail.ticket.description || ticketDetail.ticket.description_text || '(empty)'"
                    (click)="toggleConversationImage($event)"></div>
                  <div *ngIf="ticketDetail.ticket.attachments?.length" class="card-footer py-5 d-flex flex-wrap gap-5">
                    <ng-container *ngFor="let att of ticketDetail.ticket.attachments">
                      <img
                        *ngIf="att.content_type?.startsWith('image/')"
                        [src]="att.attachment_url"
                        [alt]="att.name || 'attachment'"
                        class="conversation-attachment-img"
                        (click)="toggleConversationImage($event)" />
                      <a
                        *ngIf="!att.content_type?.startsWith('image/')"
                        [href]="att.attachment_url"
                        target="_blank"
                        class="btn btn-sm btn-outline-secondary">
                        <i class="fas fa-paperclip me-5"></i>{{ att.name || 'Attachment' }}
                      </a>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <!-- Bot Decision tab -->
            <div *ngIf="ticketDetailTab === 'decision'">
              <div *ngIf="!ticketDetail.review" class="text-muted">No bot decision for this ticket.</div>

              <div *ngIf="ticketDetail.review">
                <table class="table table-sm">
                  <tbody>
                    <tr>
                      <td class="fw-bold" style="width: 160px">Action</td>
                      <td>
                        <span [ngClass]="getActionBadgeClass(ticketDetail.review.decision.action?.type)">{{
                          ticketDetail.review.decision.action?.type
                        }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="fw-bold">Confidence</td>
                      <td>{{ formatConfidence(ticketDetail.review.decision.confidence) }}</td>
                    </tr>
                    <tr>
                      <td class="fw-bold">Autoclose</td>
                      <td>{{ ticketDetail.review.decision.autoclose ? 'Yes' : 'No' }}</td>
                    </tr>
                    <tr>
                      <td class="fw-bold">Support Cases</td>
                      <td>{{ formatSupportCaseNames(ticketDetail.review.decision) }}</td>
                    </tr>
                    <tr>
                      <td class="fw-bold">Phone</td>
                      <td>{{ getResolvedPhone(ticketDetail.review.decision) || ticketDetail.review.decision.phoneNumber || '-' }}</td>
                    </tr>
                    <tr *ngIf="ticketDetail.review.decision.action?.type === 'reply'">
                      <td class="fw-bold">
                        Proposed Reply
                        <br />
                        <small *ngIf="!editingReply && canReviseTicketDetail()" class="text-muted fw-normal">click to edit</small>
                        <small *ngIf="editingReply" class="text-info fw-normal">editing</small>
                      </td>
                      <td>
                        <div
                          class="reply-editor"
                          [class.reply-editor--dimmed]="feedbackExpanded"
                          [class.reply-editor--readonly]="!canReviseTicketDetail()">
                          <!-- Read mode -->
                          <div
                            *ngIf="!editingReply"
                            #replyDisplay
                            class="reply-editor__display border rounded p-10 bg-light"
                            (click)="startEditReply()">
                            {{ ticketDetail.review.decision.action.message }}
                          </div>
                          <!-- Edit mode -->
                          <div *ngIf="editingReply" class="reply-editor__editing">
                            <textarea
                              #replyTextarea
                              class="form-control reply-editor__textarea"
                              [style.min-height.px]="replyDisplayHeight"
                              [(ngModel)]="editedReplyText"
                              (blur)="onReplyEditorBlur()"></textarea>
                            <div class="reply-editor__bar">
                              <div class="d-flex gap-5 ms-auto">
                                <button class="btn btn-sm btn-outline-secondary" (mousedown)="$event.preventDefault()" (click)="cancelEditReply()">
                                  Cancel
                                </button>
                                <button class="btn btn-sm btn-primary" (mousedown)="$event.preventDefault()" (click)="saveEditedReply()">Save</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="ticketDetail.review.decision.action?.type === 'reply' && canReviseTicketDetail()">
                      <td colspan="2" class="p-0 border-0">
                        <div class="px-10 py-10">
                          <div
                            class="feedback-composer"
                            [class.feedback-composer--expanded]="feedbackExpanded"
                            [class.feedback-composer--dimmed]="editingReply"
                            (keydown.escape)="blurFeedback()">
                            <textarea
                              #feedbackInput
                              class="feedback-composer__input"
                              [(ngModel)]="reviewRevisionComment"
                              placeholder="Re-try with feedback..."
                              (focus)="expandFeedback()"
                              (blur)="onFeedbackBlur()"
                              [rows]="1"></textarea>
                            <i *ngIf="!feedbackExpanded" class="fas fa-paper-plane feedback-composer__send-icon"></i>
                            <div *ngIf="feedbackExpanded" class="feedback-composer__footer">
                              <span class="feedback-composer__helper text-muted">The AI agent will re-review with your feedback</span>
                              <button
                                class="btn btn-sm btn-primary"
                                (mousedown)="$event.preventDefault()"
                                (click)="submitReviewRevision()"
                                [disabled]="reviewRevisionSaving || !reviewRevisionComment.trim()">
                                {{ reviewRevisionSaving ? 'Updating...' : 'Re-try' }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="ticketDetail.review.decision.action?.type === 'reply' && ticketDetail.review.decision.action?.messageLanguage">
                      <td class="fw-bold">Language</td>
                      <td>{{ ticketDetail.review.decision.action.messageLanguage }}</td>
                    </tr>
                    <tr *ngIf="ticketDetail.review.decision.action?.type === 'reply' && ticketDetail.review.decision.action?.messageTranslation">
                      <td class="fw-bold">English Translation</td>
                      <td>
                        <div class="border rounded p-10 bg-light" style="white-space: pre-wrap; max-height: 300px; overflow-y: auto">
                          {{ ticketDetail.review.decision.action.messageTranslation }}
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="ticketDetail.review.decision.action?.summary">
                      <td class="fw-bold">Summary</td>
                      <td>{{ ticketDetail.review.decision.action.summary }}</td>
                    </tr>
                    <tr *ngIf="ticketDetail.review.decision.ticketTranslation">
                      <td class="fw-bold">Translation</td>
                      <td style="white-space: pre-wrap">{{ ticketDetail.review.decision.ticketTranslation }}</td>
                    </tr>
                    <tr *ngIf="ticketDetail.review.decision.attachmentDescription">
                      <td class="fw-bold">Attachments</td>
                      <td>
                        {{ ticketDetail.review.decision.attachmentDescription }}
                        <span *ngIf="ticketDetail.review.decision.hasVideoAttachment" class="badge bg-info ms-5">Video</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="fw-bold">Reviewed At</td>
                      <td>{{ formatDate(ticketDetail.review.cachedAt) }}</td>
                    </tr>
                    <tr *ngIf="ticketDetail.review.decision.action?.type !== 'reply' && canReviseTicketDetail()">
                      <td colspan="2" class="p-0 border-0">
                        <div class="px-10 py-10">
                          <div class="feedback-composer" [class.feedback-composer--expanded]="feedbackExpanded" (keydown.escape)="blurFeedback()">
                            <textarea
                              class="feedback-composer__input"
                              [(ngModel)]="reviewRevisionComment"
                              placeholder="Re-try with feedback..."
                              (focus)="expandFeedback()"
                              (blur)="onFeedbackBlur()"
                              [rows]="1"></textarea>
                            <i *ngIf="!feedbackExpanded" class="fas fa-paper-plane feedback-composer__send-icon"></i>
                            <div *ngIf="feedbackExpanded" class="feedback-composer__footer">
                              <span class="feedback-composer__helper text-muted">The AI agent will re-review with your feedback</span>
                              <button
                                class="btn btn-sm btn-primary"
                                (mousedown)="$event.preventDefault()"
                                (click)="submitReviewRevision()"
                                [disabled]="reviewRevisionSaving || !reviewRevisionComment.trim()">
                                {{ reviewRevisionSaving ? 'Updating...' : 'Re-try' }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- User Data tab -->
            <div *ngIf="ticketDetailTab === 'data'">
              <div *ngIf="!ticketDetail.review?.decision?.promptData?.dataCollection" class="text-muted">No user data collected for this ticket.</div>

              <div *ngIf="ticketDetail.review?.decision?.promptData?.dataCollection as dc">
                <div *ngIf="dc.userAccount" class="mb-15">
                  <h6>User Account</h6>
                  <div style="max-height: 400px; overflow-y: auto">
                    <ng-container *ngTemplateOutlet="renderValue; context: { $implicit: dc.userAccount }"></ng-container>
                  </div>
                </div>
                <div *ngIf="dc.paymentRequests" class="mb-15">
                  <h6>Payment Requests</h6>
                  <div style="max-height: 400px; overflow-y: auto">
                    <ng-container *ngTemplateOutlet="renderValue; context: { $implicit: dc.paymentRequests }"></ng-container>
                  </div>
                </div>
                <div *ngIf="dc.relatedUserAccounts" class="mb-15">
                  <h6>Related Accounts</h6>
                  <div style="max-height: 400px; overflow-y: auto">
                    <ng-container *ngTemplateOutlet="renderValue; context: { $implicit: dc.relatedUserAccounts }"></ng-container>
                  </div>
                </div>
                <div *ngIf="dc.emailLinkedUserAccount" class="mb-15">
                  <h6>Email-Linked Account</h6>
                  <div style="max-height: 400px; overflow-y: auto">
                    <ng-container *ngTemplateOutlet="renderValue; context: { $implicit: dc.emailLinkedUserAccount }"></ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer pt-20">
        <button type="button" class="btn btn-outline-secondary" (click)="closeTicketDetail()">Close</button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade show" *ngIf="showTicketDetail" (click)="closeTicketDetail()"></div>

<!-- Flat value renderer for User Data -->
<ng-template #renderValue let-data>
  <!-- String / primitive -->
  <div *ngIf="!isObject(data) && !isArray(data)" class="border rounded p-10 bg-light" style="word-break: break-word">{{ data ?? '-' }}</div>
  <!-- Object: flatten to single-level table -->
  <table *ngIf="isObject(data)" class="table table-sm table-bordered mb-0" style="font-size: 13px; table-layout: fixed; width: 100%">
    <tbody>
      <tr *ngFor="let row of flattenObject(data)">
        <td class="fw-bold align-top" style="width: 180px; background: #f8f9fa; word-break: break-word">{{ row.key }}</td>
        <td style="word-break: break-word; overflow-wrap: anywhere">
          <span *ngIf="row.value !== null && row.value !== undefined">{{ row.value }}</span>
          <span *ngIf="row.value === null || row.value === undefined" class="text-muted">-</span>
        </td>
      </tr>
    </tbody>
  </table>
  <!-- Array -->
  <div *ngIf="isArray(data)">
    <div *ngFor="let item of data; let i = index" [class.mb-10]="true">
      <small *ngIf="data.length > 1" class="text-muted d-block mb-5">#{{ i + 1 }}</small>
      <ng-container *ngTemplateOutlet="renderValue; context: { $implicit: item }"></ng-container>
    </div>
    <span *ngIf="data.length === 0" class="text-muted">Empty</span>
  </div>
</ng-template>
